import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import PrizesSection from "./components/PrizesSection";
import PropertyShowcase from "./components/PropertyShowcase";
import HowItWorks from "./components/HowItWorks";
import GuterZweck from "./components/GuterZweck";
import LifestyleSection from "./components/LifestyleSection";
import Testimonials from "./components/Testimonials";
import BekanntAus from "./components/BekanntAus";
import ScrollReveal from "../../components/base/ScrollReveal";

export default function Home() {
  return (
    <main className="min-h-screen font-inter">
      <Navbar />

      {/* Hero — keine Animation, sofort sichtbar */}
      <HeroSection />

      {/* Immobilien-Showcase — Einblenden von unten */}
      <ScrollReveal variant="fade-up" duration={700}>
        <PropertyShowcase />
      </ScrollReveal>

      {/* Lifestyle — leicht verzögert */}
      <ScrollReveal variant="fade-up" duration={700} delay={80}>
        <LifestyleSection />
      </ScrollReveal>

      {/* Gewinne — stärkere Bewegung nach oben */}
      <ScrollReveal variant="fade-up" duration={750} threshold={0.08}>
        <PrizesSection />
      </ScrollReveal>

      {/* Wie es funktioniert — von links */}
      <ScrollReveal variant="fade-right" duration={700}>
        <HowItWorks />
      </ScrollReveal>

      {/* Guter Zweck — von rechts */}
      <ScrollReveal variant="fade-left" duration={700}>
        <GuterZweck />
      </ScrollReveal>

      {/* Erfahrungsberichte — sanftes Einblenden */}
      <ScrollReveal variant="fade-up" duration={700} delay={50}>
        <Testimonials />
      </ScrollReveal>

      {/* Bekannt aus — einfaches Einblenden am Ende */}
      <ScrollReveal variant="fade-up" duration={600}>
        <BekanntAus />
      </ScrollReveal>

      <Footer />
    </main>
  );
}
